import type { FieldPath } from 'react-hook-form';
import type { SystemPackageAppVersion } from '../../pages/create-system-package-version-page/createSystemPackageVersionPage.model';

export function checkMinimumDependencyFieldIsDisabled(
  disabledFields: FieldPath<SystemPackageAppVersion>[],
  fieldname: FieldPath<SystemPackageAppVersion>,
): boolean {
  return disabledFields.includes(fieldname);
}
